import React from 'react';

import NotFoundPage from '../../../components/reusable/error-pages/NotFoundPage/NotFoundPage';
import { useFeature } from '../../../hooks/use-feature';
import { AppFeatureKey } from '../../../shared/constants';
import UserPlan from './UserPlan';
import UserPlanSkeleton from './UserPlanSkeleton';

export default function UserPlanRoute() {
  const {
    [AppFeatureKey.subscriptions]: subscriptionFeatureActive,
    [AppFeatureKey.donations]: donationsFeatureActive,
    isAppFeaturesLoading,
  } = useFeature();

  if (isAppFeaturesLoading) {
    return <UserPlanSkeleton />;
  }

  if (!subscriptionFeatureActive && !donationsFeatureActive) {
    return <NotFoundPage />;
  }

  return <UserPlan />;
}
